import React from 'react';
import CartIcon from '../../content/CartIcon';
import Chevron from '../../content/Chevron';

export const CartToggleButtonTestId = 'carttogglebutton-input';

export type CartToggleButtonProps = {
  children: string;
  isCartOpen: boolean;
  toggleOpenState: () => void;
};

const CartToggleButton: React.FC<CartToggleButtonProps> = ({
  children,
  isCartOpen,
  toggleOpenState,
}: CartToggleButtonProps) => {
  return (
    <div
      className="primary-button cart-toggle-button float-right text-center p-1"
      onClick={toggleOpenState}
      data-testid={CartToggleButtonTestId}
      role="button"
      tabIndex={0}
      onKeyDown={toggleOpenState}
    >
      <span className="ml-1 mr-2 float-left cart-icon-position">
        <CartIcon />
      </span>
      <span className="font-medium text-md primary-button-icon-color">
        {children}
      </span>
      <span className="ml-2 float-right cart-chevron-position">
        <Chevron isPointingUp={isCartOpen} />
      </span>
    </div>
  );
};

export default CartToggleButton;
